import { useRouter } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import { isInvitationAcceptPathname } from '@/lib/invitation-routes';
import { useAppBootstrap } from '@/providers/useAppBootstrap';
import { useAuth } from '@/providers/useAuth';

export function PassiveAuthLoginTrigger() {
    const router = useRouter();
    const { status } = useAppBootstrap();
    const { login } = useAuth();
    const loginRequestedRef = useRef(false);

    useEffect(() => {
        if (status !== 'awaiting-auth') {
            return;
        }

        const loginOutsideInvitationRoutes = () => {
            const location = router.state.resolvedLocation ?? router.state.location;

            if (loginRequestedRef.current || isInvitationAcceptPathname(location.pathname)) {
                return;
            }

            loginRequestedRef.current = true;
            void login();
        };

        loginOutsideInvitationRoutes();

        return router.subscribe('onResolved', loginOutsideInvitationRoutes);
    }, [login, router, status]);

    return null;
}
